import qs from "qs";
import { uuid as UUID } from "@t8891/helper";
export var uuid = UUID;
var flow_id = function flow_id() {
  var _a;
  if (typeof sessionStorage !== "undefined") {
    var flowId = sessionStorage.getItem("flow_id");
    if (!!flowId) {
      return flowId;
    } else {
      var _qs$parse = qs.parse(window.location.search, {
          ignoreQueryPrefix: true
        }),
        queryFlowId = _qs$parse.flow_id;
      var flow_id_ = queryFlowId || ((_a = window.ITEM_INFO) === null || _a === void 0 ? void 0 : _a.flow_id) || uuid();
      sessionStorage.setItem("flow_id", flow_id_);
      return flow_id_;
    }
  }
};
export default flow_id;